<template>
  <div>
    <el-dialog
      width="375px"
      title="編輯費率"
      :visible.sync="editModal"
      append-to-body
    >
      <el-form
        :model="currentData"
        class="demo-form-inline"
        label-position="top"
      >
        <el-form-item label="用戶號">
          <el-input
            disabled
            v-model="currentData.user_id"
            placeholder="用戶號"
          ></el-input>
        </el-form-item>
        <el-form-item label="手續費(單筆)">
          <el-input
            v-model="currentData.fee"
            placeholder="手續費(單筆)"
          ></el-input>
        </el-form-item>
        <el-form-item label="手續費(%)">
          <el-input
            v-model="currentData.rate"
            placeholder="手續費(%)"
          ></el-input>
        </el-form-item>
        <el-form-item label="最低限額">
          <el-input
            v-model="currentData.lower"
            placeholder="最低限額"
          ></el-input>
        </el-form-item>
        <el-form-item label="最高限額">
          <el-input
            v-model="currentData.upper"
            placeholder="最高限額"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editModal = false" class="btn">關閉</div>
        <div @click="confirmEdit" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      width="375px"
      title="新增費率"
      :visible.sync="addModal"
      append-to-body
    >
      <el-form :model="addData" class="demo-form-inline" label-position="top">
        <el-form-item label="用戶號">
          <el-input v-model="addData.user_id" placeholder="用戶號"></el-input>
        </el-form-item>
        <el-form-item label="手續費(單筆)">
          <el-input v-model="addData.fee" placeholder="手續費(單筆)"></el-input>
        </el-form-item>
        <el-form-item label="手續費(%)">
          <el-input v-model="addData.rate" placeholder="手續費(%)"></el-input>
        </el-form-item>
        <el-form-item label="最低限額">
          <el-input v-model="addData.lower" placeholder="最低限額"></el-input>
        </el-form-item>
        <el-form-item label="最高限額">
          <el-input v-model="addData.upper" placeholder="最高限額"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="addModal = false" class="btn">關閉</div>
        <div @click="confirmAdd" class="btn">確認</div>
      </div>
    </el-dialog>
    <div style="margin-top:18px">
      <el-button @click="add" size="mini">新增費率 </el-button>
      <el-table
        stripe
        :data="dataList"
        border
        style="width: 100%;margin-top:18px"
      >
        <el-table-column
          header-align="center"
          align="center"
          label="用戶號"
          prop="user_id"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="手續費(單筆)"
          prop="fee"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="手續費(%)"
          prop="rate"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.rate | decimalPoint }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          label="用戶號"
          prop="user_id"
        >
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          label="最低限額"
          prop="lower"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="最高限額"
          prop="upper"
          width="200px"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button @click="editData(scope.row)" size="mini"
                >編輯
              </el-button>
              <el-button @click="delData(scope.row)" size="mini"
                >刪除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          :current-page.sync="page"
          layout="prev, pager, next"
          :page-count="pagination.total_page"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pagination: {},
      page: 1,
      currentData: {},
      dataList: [],
      addModal: false,
      editModal: false,
      addData: {}
    };
  },
  methods: {
    delData(data) {
      this.$alert(`確定刪除${data.user_id}?`, "刪除費率", {
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        beforeClose: (method, instance, done) => {
          if (method == "confirm") {
            this.$http.delete(`/back/withdraws/fee/${data.id}`).then(res => {
              if (res.data.code == 0) {
                this.$message.success("成功");
                this.getData();
                done();
              } else {
                done();
              }
            });
          } else {
            done();
          }
        }
      });
    },
    confirmEdit() {
      this.$http
        .put(`/back/withdraws/fee/${this.currentData.id}`, this.currentData)
        .then(res => {
          if (res.data.code == 0) {
            this.editModal = false;
            this.getData();
            this.$message.success("成功");
          }
        });
    },
    editData(data) {
      let currentData = JSON.parse(JSON.stringify(data));
      currentData.rate = this.$options.filters.decimalPoint(currentData.rate);
      this.currentData = currentData;
      this.editModal = true;
    },
    confirmAdd() {
      this.$http.post(`/back/withdraws/fee`, this.addData).then(res => {
        if (res.data.code == 0) {
          this.$message.success("成功");
          this.getData();
          this.addModal = false;
        }
      });
    },
    add() {
      this.addModal = true;
      this.addData = {};
    },
    getData() {
      this.$http.get(`/back/withdraws/fee?page=${this.page}`).then(res => {
        if (res.data.code == 0) {
          this.dataList = res.data.data;
          this.pagination = res.data.paginate;
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
